<app-modal-header title="Datamorf is now Onion" (onClose)="dialogRef.close()"></app-modal-header>

<mat-dialog-content>

  <div class="panel panel-flat flex items-center justify-center gap-5 sm:gap-8 py-5 mb-5">
    <img class="h-6 sm:h-7 " src="./assets/img/logos/logo-full.png" alt="Datamorf logo">
    <i class="fas fa-arrow-right text-gray-300"></i>
    <img class="h-7 sm:h-8" src="./assets/img/logos/onion.png" alt="Onion logo">
  </div>

  <p class="text-sm text-gray-600 mb-5">
    Same team, same platform, same data. Datamorf is now Onion, and everything you have already
    built keeps running exactly as it did.
  </p>

  <!-- The domain change is the only part of this that can lock someone out, so it goes first. -->
  <div class="panel mb-5">
    <div class="flex items-start gap-3">
      <span class="w-9 h-9 rounded-xl bg-primary-50 text-primary-700 flex items-center justify-center shrink-0">
        <i class="fas fa-right-to-bracket"></i>
      </span>
      <div class="min-w-0">
        <h4 class="heading-xs mb-1">Log in at {{newAppHost}} from now on</h4>
        <p class="text-sm text-gray-500">
          That is <strong>onionos.io</strong>, for Onion OS.
        </p>
        <p class="text-sm text-gray-500 mt-2">
          app.datamorf.io still works today, but it will be retired. Change your bookmark now
          and the switch off will pass you by.
        </p>
<!--        <p class="text-sm text-gray-500 mt-2">-->
<!--          The website moved too:-->
<!--          <a class="basic-link" [href]="newSite" target="_blank" rel="noopener">onionos.io</a>-->
<!--        </p>-->
        <a class="btn btn-primary btn-sm mt-3 inline-flex" *ngIf="onOldDomain"
           [href]="newAppUrl">
          Continue on {{newAppHost}} <i class="fas fa-arrow-right ml-1"></i>
        </a>
      </div>
    </div>
  </div>

  <h4 class="heading-xs mb-2">Why Onion?</h4>
  <p class="text-sm text-gray-600 mb-5">
    Because a commercial operation has layers, and we were only ever automating one of them.
    Onion covers the whole commercial lifecycle: deciding who you should be selling to, running
    the automations that reach them, and seeing what came of it. Workflows and engines are still
    the core of the product. The rest is built around them.
  </p>

  <h4 class="heading-xs mb-3">What that added</h4>
  <div class="space-y-3 mb-2">
    <div class="flex items-start gap-3">
      <span class="w-9 h-9 rounded-xl bg-sky-50 text-sky-500 flex items-center justify-center shrink-0">
        <i class="fas fa-bullseye"></i>
      </span>
      <div>
        <p class="text-sm font-semibold">Commercial Thesis</p>
        <p class="text-sm text-gray-500">
          An AI helps you define your ICP, or several of them, so everything downstream knows
          what a 10 out of 10 company actually looks like for you.
        </p>
      </div>
    </div>

    <div class="flex items-start gap-3">
      <span class="w-9 h-9 rounded-xl bg-emerald-50 text-emerald-500 flex items-center justify-center shrink-0">
        <i class="fas fa-puzzle-piece"></i>
      </span>
      <div>
        <p class="text-sm font-semibold">Built in workflow steps</p>
        <p class="text-sm text-gray-500">
          The common commercial jobs now come ready made instead of assembled by hand, and we
          are adding more of them all the time.
        </p>
      </div>
    </div>

    <div class="flex items-start gap-3">
      <span class="w-9 h-9 rounded-xl bg-cyan-50 text-cyan-500 flex items-center justify-center shrink-0">
        <i class="far fa-calendar-check"></i>
      </span>
      <div>
        <p class="text-sm font-semibold">Meeting scheduler</p>
        <p class="text-sm text-gray-500">
          Booking links that put meetings on your calendar and record what sourced them, so the
          small tools your operation runs on live in the same place as the rest of it.
        </p>
      </div>
    </div>

    <div class="flex items-start gap-3">
      <span class="w-9 h-9 rounded-xl bg-violet-50 text-violet-500 flex items-center justify-center shrink-0">
        <i class="fas fa-chart-line"></i>
      </span>
      <div>
        <p class="text-sm font-semibold">Commercial Dashboard</p>
        <p class="text-sm text-gray-500">
          Everything happening across your tool stack, tracked and drawn in one view, so you can
          see the state of your operation at any moment.
        </p>
      </div>
    </div>
  </div>

  <p class="text-xs text-gray-400 mt-5">
    You can reopen this any time from "Why we're Onion", at the bottom of the menu.
  </p>

</mat-dialog-content>
